import * as angular from 'angular';

import { ComponentDefinition } from '@models/index';
import { SpotManualInputsWidget } from 'widgets/widgets.index';

class SpotValuesPanelButtonsController implements angular.IComponentController {
    readonly addRow: () => void;
    readonly cancel: () => void;
    readonly formController: angular.IFormController;
    readonly hasBulkInsert: boolean;
    readonly hasReadonlyMode: boolean;
    readonly isEditMode: boolean;
    readonly item: SpotManualInputsWidget;
    readonly save: () => void;
    readonly setEditMode: () => void;

    static $inject = [];
}
 
export const wtSpotValuesPanelButtons: ComponentDefinition = {
    componentId: 'wtSpotValuesPanelButtons',
    controller: SpotValuesPanelButtonsController,
    template: require('./spotValuesPanelButtons.component.html'),
    controllerAs: 'vm',
    bindings: {
        addRow: '&',
        bulkModalId: '@',
        cancel: '&',
        formController: '<',
        hasBulkInsert: '<',
        hasReadonlyMode: '<',
        isEditMode: '<',
        item: '<',
        save: '&',
        setEditMode: '&?'
    }
};
